const ProfilSearch = {
    idSekolah: null,
    idProfilCbt: null,
    idKelas: null,
    idKurikulum: null,
    namaProfil: null,
    cbtOwner: null,
    kodeTipeCbt: null,
    kodeSubTipeCbt: null,
    kodeJenjangSekolah: null,
    idKelasParalel: null,
    kodeTahunAjaran: null
}

export default ProfilSearch;